import { Type } from 'class-transformer';
import { WFEWorkflowRawDto } from '../../../shared-workflow-module/_models/wfe-workflow-raw-dto';
import { WorkflowCheckListRawDto } from '../../../shared-workflow-module/_models/workflow-check-list-raw-dto';

export class WFEApproveCamAcctStepParametersDto {
    @Type(() => WorkflowCheckListRawDto)
    workflowChecklistStatus: Array<WorkflowCheckListRawDto>;

    @Type(() => WFEWorkflowRawDto)
    workflow: WFEWorkflowRawDto;

    createTemplate: boolean;
    closeWorkOrderIds: Array<number>;
}
